import API from "shared/services/Api";
import { IAparelhoResponse } from "shared/types/Aparelho";

export const getAparelhos = async (data: {
  userId: string;
}): Promise<IAparelhoResponse> => API.get(`oc/aparelhos?id=${data.userId}`);
